export const NONE = {code: "", text: "Select Priority"}
export const HIGH_PRIORITY = {code: "High", text: "High"}
export const LOW_PRIORITY = {code: "Low", text: "Low"}

export const fetchInfrigementAllPriority = () => {
    return [
        NONE,HIGH_PRIORITY,LOW_PRIORITY
    ]
}